import Parcelle from 'entity/Parcelle'
import { ReactComponent as PictoPiscine } from 'assets/default/svg/picto_piscine.svg'
import { ReactComponent as PictoMaison } from 'assets/default/svg/picto_maison.svg'
import { ReactComponent as PictoTerrain } from 'assets/default/svg/picto_terrain.svg'
import { ReactComponent as PictoSurfaceHabitable } from 'assets/default/svg/picto_surface_habitable.svg'
import { ReactComponent as PictoSurfaceSol } from 'assets/default/svg/picto_surface_sol.svg'
import { ReactComponent as PictoPiece } from 'assets/default/svg/picto_nb_pieces.svg'
import PictoAndTextList, {
  PictoAndTextListElement,
} from 'layouts/PictoAndTextListLayout/PictoAndTextList'
import pluralizer from 'utils/pluralizer'

interface Props {
  parcelle: Parcelle
}

const InformationList = ({ parcelle }: Props): JSX.Element => {
  const { surfaceTerrain, swimmingPool, parcelleType, batiList, historique } =
    parcelle

  const history = historique[0] || null

  const list: PictoAndTextListElement[] = []
  list.push({
    picto: <PictoTerrain />,
    text: `${surfaceTerrain} m² de terrain`,
  })
  if (swimmingPool) {
    list.push({ picto: <PictoPiscine />, text: `Piscine` })
  }
  if (parcelleType === 'simple' && history) {
    list.push({ picto: <PictoMaison />, text: `Maison` })
    list.push({
      picto: <PictoPiece />,
      text: `${history.nbPiece} ${pluralizer('pièce', history.nbPiece)}`,
    })
    list.push({
      picto: <PictoSurfaceHabitable />,
      text: `${history.surfaceHabitable} m² habitables`,
    })
  }
  if (parcelleType === 'simple' && batiList.length > 0) {
    list.push({
      picto: <PictoSurfaceSol />,
      text: `${Math.round(parcelle.batiList[0].valueOf())} m² au sol`,
    })
  }

  return <PictoAndTextList list={list} />
}

export default InformationList
